import React from "react";
import { Button } from "react-bootstrap";
import HeaderLayout from "./HeaderLayout";
import CardsLayout from "./cardsLayout";
import { Link } from "react-router-dom";
import {
  getVendorInformationByVendorAndDC,
  updateVendorInformationByVendorAndDC
} from "../../../actions";
import Spinner from "../../common/Spinner";
import Sanckbar from "../../common/Sanckbar";
import StatusModal from "../../common/StatusModal";

class ManageVendorInformationByDc extends React.Component {
  state = {
    notificationMsg: "",
    isSaveEnabled: false
  };
  constructor() {
    super();
    this.cardsData = [];
    this.allData = {};
    this.oldInfo = [];
    this.newInfo = {};
  }
  componentDidMount() {
    document.addEventListener("keydown", this.pressEnter);
  }
  setErrorMessage = msg => {
    this.setNotification(msg, "red", "cancel");
  };
  setWarningMessage = msg => {
    this.setNotification(msg, "orange", "warning", 3000);
  };
  setSuccessMessage = msg => {
    this.setNotification(msg, "#47fb47", "check", 3000);
  };
  setTransitioMessage = msg => {
    this.setNotification(msg, null, null);
  };
  setNotification = (text, color, icon, timeout) => {
    clearTimeout(this.snackbarTimer);

    if (text) {
      this.setState({ notificationMsg: { text, color, icon } });
      this.setState({ isNotificationOpened: true });
    } else {
      this.setState({ isNotificationOpened: false });
    }
    if (timeout) {
      this.snackbarTimer = setTimeout(() => {
        this.setState({ isNotificationOpened: false });
      }, timeout);
    }
  };
  lookup = msg => {
    this.setTransitioMessage(<Spinner msg="Loading..." />);
    if (this.state.lookup && this.state.lookup.item && this.state.lookup.wse) {
      var item = this.state.lookup.item;
      getVendorInformationByVendorAndDC(item, this.state.lookup.wse).then(
        res => {
          msg ? this.setSuccessMessage(msg) : this.setTransitioMessage("");

          var data = [];
          if (res.data.success) {
            data = res.data.data;
          } else {
            data = false;
            this.setErrorMessage("Nothing found.");
          }
          this.setState({ data });
          this.setState({
            header: [
              {
                label: "Vendor",
                name: "vendor",
                value: data === false ? " " : data.vendor
              },
              {
                label: "Vendor Name",
                name: "vname",
                value: data === false ? " " : data.vname
              },
              {
                label: "Warehouses",
                name: "wse",
               // value: data === false ? false : data.whsesForItem
              },
              {
                label: "Broker",
                name: "broker",
                value: data === false ? " " : data.broker
              }
            ],
            cards: [
              {
                Terms: [
                  {
                    label: "Order",
                    name: "order",
                    value: data === false ? " " : data.order
                  },
                  {
                    label: "PO Mgmt Type",
                    name: "vWhsePOType",
                    value: data === false ? " " : data.vWhsePOType
                  },
                  {
                    label: "Collect",
                    name: "freightCollect",
                    value: data === false ? " " : data.freightCollect
                  },
                  {
                    label: "Freight",
                    name: "freight",
                    value: data === false ? " " : data.freight
                  },
                  {
                    label: "Console Code",
                    name: "consolCode",
                    value: data === false ? " " : data.consolCode
                  },
                  {
                    label: "Active Flag",
                    name: "activeFlag",
                    value: data === false ? " " : data.activeFlag
                  },
                  {
                    label: "Backorder Cancel Days",
                    name: "bkordCancelDays",
                    value: data === false ? " " : data.bkordCancelDays
                  },
                  {
                    label: "PO Fill Percentage",
                    name: "rrFillPercent",
                    value: data === false ? " " : data.rrFillPercent
                  },
                  {
                    label: "Agreement Lead Time",
                    name: "agreemntLeadTime",
                    value: data === false ? " " : data.agreemntLeadTime
                  },
                  {
                    label: "Backhaul Flag",
                    name: "backhaulFlag",
                    value: data === false ? " " : data.backhaulFlag
                  },
                  {
                    label: "DSD Lead Time",
                    name: "leadTimeDSD",
                    value: data === false ? " " : data.leadTimeDSD
                  },
                  {
                    label: "Input Lead Time",
                    name: "leadTimePolicy",
                    value: data === false ? " " : data.leadTimePolicy
                  },
                  {
                    label: "Calc Lead Time",
                    name: "leadTimeActual",
                    value: data === false ? " " : data.leadTimeActual
                  },
                  {
                    label: "Lead Time Pad",
                    name: "ltPadDays",
                    value: data === false ? " " : data.ltPadDays
                  },
                  {
                    label: "Variability",
                    name: "leadTimeVary",
                    value: data === false ? " " : data.leadTimeVary
                  },
                  {
                    label: "Open on Sat",
                    name: "vendorOpenSat",
                    value: data === false ? " " : data.vendorOpenSat
                  },
                  {
                    label: "Sun",
                    name: "vendorOpenSun",
                    value: data === false ? " " : data.vendorOpenSun
                  },
                  {
                    label: "Current",
                    name: "pOCurrencyCode",
                    value: data === false ? " " : data.pOCurrencyCode
                  },
                  {
                    label: "Logistics Export",
                    name: "logisticsExport",
                    value: data === false ? " " : data.logisticsExport
                  },
                  {
                    label: "Transit Days",
                    name: "transitDays",
                    value: data === false ? " " : data.transitDays
                  },
                  {
                    label: "FedEx Export",
                    name: "fedexExport",
                    value: data === false ? " " : data.fedexExport
                  },
                  {
                    label: "Logistic Returns",
                    name: "logisticsReturns",
                    value: data === false ? " " : data.logisticsReturns
                  },
                  {
                    label: "",
                    name: "OrderDays",
                    value: data === false ? " " : data.OrderDays
                  },
                  {
                    label: "Mon",
                    name: "ordMonday",
                    value: data === false ? " " : data.ordMonday
                  },
                  {
                    label: "Tue",
                    name: "ordTuesday",
                    value: data === false ? " " : data.ordTuesday
                  },
                  {
                    label: "Wed",
                    name: "ordWednesday",
                    value: data === false ? " " : data.ordWednesday
                  },
                  {
                    label: "Thu",
                    name: "ordThursday",
                    value: data === false ? " " : data.ordThursday
                  },
                  {
                    label: "Fri",
                    name: "ordFriday",
                    value: data === false ? " " : data.ordFriday
                  },
                  {
                    label: "Rvw Time",
                    name: "revTime",
                    value: data === false ? " " : data.revTime
                  },
                  {
                    label: "",
                    name: "DailyLT",
                    value: data === false ? " " : data.DailyLT
                  },
                  {
                    label: "Mon",
                    name: "leadDaysMon",
                    value: data === false ? " " : data.leadDaysMon
                  },
                  {
                    label: "Tue",
                    name: "leadDaysTue",
                    value: data === false ? " " : data.leadDaysTue
                  },
                  {
                    label: "Wed",
                    name: "leadDaysWed",
                    value: data === false ? " " : data.leadDaysWed
                  },
                  {
                    label: "Thu",
                    name: "leadDaysThu",
                    value: data === false ? " " : data.leadDaysThu
                  },
                  {
                    label: "Fri",
                    name: "leadDaysFri",
                    value: data === false ? " " : data.leadDaysFri
                  },
                  {
                    label: "Cntry",
                    name: "countryCode",
                    value: data === false ? " " : data.countryCode
                  }
                ]
              },
              {
                "Payment Terms": [
                  {
                    label: "Discount Percent",
                    name: "discountPcnt",
                    value: data === false ? " " : data.discountPcnt
                  },
                  {
                    label: "Discount Days",
                    name: "discountDays",
                    value: data === false ? " " : data.discountDays
                  },
                  {
                    label: "Net Days",
                    name: "netDays",
                    value: data === false ? " " : data.netDays
                  },
                  {
                    label: "No. of Payments",
                    name: "numPayments",
                    value: data === false ? " " : data.numPayments
                  },
                  {
                    label: "Day of Month",
                    name: "dayMonth",
                    value: data === false ? " " : data.dayMonth
                  },
                  {
                    label: "No. of Months",
                    name: "numOfMonths",
                    value: data === false ? " " : data.numOfMonths
                  }
                ]
              },
              {
                card3: [
                  {
                    label: data === false ? "." : "",
                    name: "grp1ttl1",
                    value: data === false ? " " : data.grp1ttl1
                  },
                  {
                    label: data === false ? "." : "",
                    name: "grp1ttl2",
                    value: data === false ? " " : data.grp1ttl2
                  },
                  {
                    label: data === false ? "." : "",
                    name: "grp1ttl3",
                    value: data === false ? " " : data.grp1ttl3
                  },
                  {
                    label: data === false ? "." : "",
                    name: "grp2ttl1",
                    value: data === false ? " " : data.grp2ttl1
                  },
                  {
                    label: data === false ? "." : "",
                    name: "grp2ttl2",
                    value: data === false ? " " : data.grp2ttl2
                  },
                  {
                    label: data === false ? "." : "",
                    name: "grp2ttl3",
                    value: data === false ? " " : data.grp2ttl3
                  },
                  {
                    label: data === false ? "." : "",
                    name: "grp3ttl1",
                    value: data === false ? " " : data.grp3ttl1
                  },
                  {
                    label: data === false ? "." : "",
                    name: "grp3ttl2",
                    value: data === false ? " " : data.grp3ttl2
                  },
                  {
                    label: data === false ? "." : "",
                    name: "grp3ttl3",
                    value: data === false ? " " : data.grp3ttl3
                  },
                  {
                    label: data === false ? "." : "",
                    name: "grp4ttl1",
                    value: data === false ? " " : data.grp4ttl1
                  },
                  {
                    label: data === false ? "." : "",
                    name: "grp4ttl2",
                    value: data === false ? " " : data.grp4ttl2
                  },
                  {
                    label: data === false ? "." : "",
                    name: "grp4ttl3",
                    value: data === false ? " " : data.grp4ttl3
                  },
                  {
                    //: " . ",
                    name: "ordRecvdDate1",
                    label: data === false ? "." : data.ordRecvdDate1
                  },
                  {
                    //: " . ",
                    name: "ordSkupLtu1",
                    label: data === false ? "." : data.ordSkupLtu1
                  },
                  {
                    //: " . ",
                    name: "ordSupplyRecvd1",
                    label: data === false ? "." : data.ordSupplyRecvd1
                  },
                  {
                    //: " . ",
                    name: "ordRecvdDate2",
                    label: data === false ? "." : data.ordRecvdDate2
                  },
                  {
                    //: " . ",
                    name: "ordSkupLtu2",
                    label: data === false ? "." : data.ordSkupLtu2
                  },
                  {
                    //: " . ",
                    name: "ordSupplyRecvd2",
                    label: data === false ? "." : data.ordSupplyRecvd2
                  },
                  {
                    //: " . ",
                    name: "ordRecvdDate3",
                    label: data === false ? "." : data.ordRecvdDate3
                  },
                  {
                    //: " . ",
                    name: "ordSkupLtu3",
                    label: data === false ? "." : data.ordSkupLtu3
                  },
                  {
                    //: " . ",
                    name: "ordSupplyRecvd3",
                    label: data === false ? "." : data.ordSupplyRecvd3
                  },
                  {
                    //: " . ",
                    name: "ordRecvdDate4",
                    label: data === false ? "." : data.ordRecvdDate4
                  },
                  {
                    //: " . ",
                    name: "ordSkupLtu4",
                    label: data === false ? "." : data.ordSkupLtu4
                  },
                  {
                    //: " . ",
                    name: "ordSupplyRecvd4",
                    label: data === false ? "." : data.ordSupplyRecvd4
                  },
                  {
                    //: " . ",
                    name: "ordRecvdDate5",
                    label: data === false ? "." : data.ordRecvdDate5
                  },
                  {
                    //: " . ",
                    name: "ordSkupLtu5",
                    label: data === false ? "." : data.ordSkupLtu5
                  },
                  {
                    //: " . ",
                    name: "ordSupplyRecvd5",
                    label: data === false ? "." : data.ordSupplyRecvd5
                  },
                  {
                    //: " . ",
                    name: "ordRecvdDate6",
                    label: data === false ? "." : data.ordRecvdDate6
                  },
                  {
                    //: " . ",
                    name: "ordSkupLtu6",
                    label: data === false ? "." : data.ordSkupLtu6
                  },
                  {
                    //: " . ",
                    name: "ordSupplyRecvd6",
                    label: data === false ? "." : data.ordSupplyRecvd6
                  },
                  {
                    //: " . ",
                    name: "ordRecvdDate7",
                    label: data === false ? "." : data.ordRecvdDate7
                  },
                  {
                    //: " . ",
                    name: "ordSkupLtu7",
                    label: data === false ? "." : data.ordSkupLtu7
                  },
                  {
                    //: " . ",
                    name: "ordSupplyRecvd7",
                    label: data === false ? "." : data.ordSupplyRecvd7
                  },
                  {
                    //: " . ",
                    name: "ordRecvdDate8",
                    label: data === false ? "." : data.ordRecvdDate8
                  },
                  {
                    //: " . ",
                    name: "ordSkupLtu8",
                    label: data === false ? "." : data.ordSkupLtu8
                  },
                  {
                    //: " . ",
                    name: "ordSupplyRecvd8",
                    label: data === false ? "." : data.ordSupplyRecvd8
                  },
                  {
                    //: " . ",
                    name: "ordRecvdDate9",
                    label: data === false ? "." : data.ordRecvdDate9
                  },
                  {
                    //: " . ",
                    name: "ordSkupLtu9",
                    label: data === false ? "." : data.ordSkupLtu9
                  },
                  {
                    //: " . ",
                    name: "ordSupplyRecvd9",
                    label: data === false ? "." : data.ordSupplyRecvd9
                  },
                  {
                    //: " . ",
                    name: "ordRecvdDate10",
                    label: data === false ? "." : data.ordRecvdDate10
                  },
                  {
                    //: " . ",
                    name: "ordSkupLtu10",
                    label: data === false ? "." : data.ordSkupLtu10
                  },
                  {
                    //: " . ",
                    name: "ordSupplyRecvd10",
                    label: data === false ? "." : data.ordSupplyRecvd10
                  },
                  {
                    //: " . ",
                    name: "ordRecvdDate11",
                    label: data === false ? "." : data.ordRecvdDate11
                  },
                  {
                    //: " . ",
                    name: "ordSkupLtu11",
                    label: data === false ? "." : data.ordSkupLtu11
                  },
                  {
                    //: " . ",
                    name: "ordSupplyRecvd11",
                    label: data === false ? "." : data.ordSupplyRecvd11
                  },
                  {
                    //: " . ",
                    name: "ordRecvdDate12",
                    label: data === false ? "." : data.ordRecvdDate12
                  },
                  {
                    //: " . ",
                    name: "ordSkupLtu12",
                    label: data === false ? "." : data.ordSkupLtu12
                  },
                  {
                    //: " . ",
                    name: "ordSupplyRecvd12",
                    label: data === false ? "." : data.ordSupplyRecvd12
                  }
                ]
              },
              {
                "BackHaul Pickup Info": [
                  {
                    label: "Name",
                    name: "pickupName",
                    value: data === false ? " " : data.pickupName
                  },
                  {
                    label: "Address",
                    name: "pickupAddress",
                    value: data === false ? " " : data.pickupAddress
                  },
                  {
                    label: "City",
                    name: "pickupCity",
                    value: data === false ? " " : data.pickupCity
                  },
                  {
                    label: "State",
                    name: "pickupState",
                    value: data === false ? " " : data.pickupState
                  },
                  {
                    label: "Zip",
                    name: "pickupZip",
                    value: data === false ? " " : data.pickupZip
                  },
                  {
                    label: "Contact",
                    name: "pickupContact",
                    value: data === false ? " " : data.pickupContact
                  },
                  {
                    label: "Phone",
                    name: "pickupPhone",
                    value: data === false ? " " : data.pickupPhone
                  },
                  {
                    label: "Hours",
                    name: "pickupHours",
                    value: data === false ? " " : data.pickupHours
                  },
                  {
                    label: "PO Note",
                    name: "pONote",
                    value: data === false ? " " : data.pONote
                  }
                ]
              }
            ]
          });
        }
      ).catch(err => {
        const code = String(err).split('code')[1];
        if(code == 401) {
          this.setErrorMessage(`Error code ${code}, token expired, please login again.`);
          setTimeout(() => {
            this.setErrorMessage();
          }, 3000);
        } else {
            this.setErrorMessage(`Error code ${code}, cannot complete the action now, please try again later.`);
            setTimeout(() => {
              this.setErrorMessage();
            }, 3000);
        }
      });
    } else {
      this.setErrorMessage("Please type vendor and select a warehouse");
      setTimeout(() => {
        this.setErrorMessage();
      }, 2000);
    }
  };
  getHeaderInfo = value => {
    this.setState({
      lookup: {
        item: value.header.vendor,
        wse: value.header.wse ? value.header.wse[0] : 0,
        whses: value.header.wse
      }
    });

    this.handleInformation(value);
  };
  getCardsInfo = value => {
    this.handleInformation(value);
  };
  handleInformation = value => {
    Object.keys(value[Object.keys(value)]).map(
      val => (this.allData[val] = value[Object.keys(value)][val])
    );
    if (this.state.data) {
      for (let i = 0; i < Object.keys(this.state.data).length; i++) {
        this.newInfo[Object.keys(this.state.data)[i]] = this.allData[
          Object.keys(this.state.data)[i]
        ]
          ? this.allData[Object.keys(this.state.data)[i]]
          : this.state.data[Object.keys(this.state.data)[i]];
      }
      this.checkHotChanges();
    }
  };
  checkHotChanges = () => {
    this.setState({
      isSaveEnabled:
        JSON.stringify(this.state.data).replace(/"/g, "") !==
        JSON.stringify(this.newInfo).replace(/"/g, "")
    });
  };
  pressEnter = e => {
    if (e.key === "Enter") {
      this.lookup();
    }
  };

  save = () => {
    const formattedWhses = this.state.lookup.whses.map(wse => {
      return wse.toString();
    });
    var uId = sessionStorage.getItem("uId");
    var obj = {
      audit: {
        userId: uId
      },
      whses: formattedWhses,
      data: this.newInfo
    };
    this.setTransitioMessage(<Spinner msg="Saving..." />);
    updateVendorInformationByVendorAndDC(obj).then(res => {
      if (res.data.success) {
        this.setState({ data: "" });
        this.newInfo = {};
        this.lookup("Item was successfully updated");
        this.setSuccessMessage("Item was successfully updated");
        this.setState({ isSaveEnabled: false });
        this.lookup();
      } else {
        this.setErrorMessage(res.data.messages[0].text);
      }
    }).catch(err => {
      const code = String(err).split('code')[1];
      if(code == 401) {
        this.setErrorMessage(`Error code ${code}, token expired, please login again.`);
        setTimeout(() => {
          this.setErrorMessage();
        }, 3000);
      } else {
          this.setErrorMessage(`Error code ${code}, cannot complete the action now, please try again later.`);
          setTimeout(() => {
            this.setErrorMessage();
          }, 3000);
      }
    });
  };

  numberToZeroPadded = (num, z) => {
    var no = parseInt(num, 10);
    num = no.toString();
    var zeroNo = z - num.length;
    var zeros = "";
    for (let i = 0; i < zeroNo; i++) {
      zeros = "0" + zeros;
    }
    return zeros + no;
  };

  componentWillUnmount() {
    document.removeEventListener("keydown", this.pressEnter);
  }

  handleOpenModal = () => {
    this.state.modalOpen
      ? this.setState({ modalOpen: false })
      : this.setState({ modalOpen: true });
  };
  closeModal = e => {
    this.setState({ modalOpen: false });
  };
  closeEP = x => {
    if (x) {
      x.target.textContent === "Save"
        ? this.save()
        : this.setSuccessMessage("Changes discarded");

      setTimeout(() => {
        this.closeEP();
      }, 1500);
    } else {
      this.props.history.push("/");
    }
  };

  checkHotChangesAndClose = () => {
    if (this.state.isSaveEnabled) {
      this.handleOpenModal();
    } else {
      this.closeEP();
    }
  };

  render() {
    return (
      <div className="container-fluid" id="example">
        <h3 className="page-title" style={{ textAlign: "center" }}>
          Manage Vendor Information By DC
        </h3>
        <div style={{ transform: "scaleY(.95)", transformOrigin: "top" }}>
          <HeaderLayout
            setHeaderInfo={this.getHeaderInfo}
            setErrorMessage={this.setErrorMessage}
            setSuccessMessage={this.setSuccessMessage}
            lookup={this.lookup}
            headerData={this.state.header}
          />
          <CardsLayout
            cardsData={this.state.cards}
            setCardsInfo={this.getCardsInfo}
            checkOrderConstraints={this.checkOrderConstraints}
          />
        </div>
        <div className="button-bar">
          <div className="paginator" style={{ display: "flex" }} />
          <div className="buttons">
            <Button
              bsStyle="warning"
              className="btn-sm"
              disabled={false}
              onClick={e => this.checkHotChangesAndClose()}
            >
              Close
            </Button>
            <Button
              bsStyle="warning"
              className="btn-sm"
              disabled={!this.state.isSaveEnabled}
              onClick={e => this.save()}
            >
              Save
            </Button>
          </div>
        </div>
        <Sanckbar
          mounted={this.state.isNotificationOpened}
          msg={{
            text: this.state.notificationMsg.text,
            color: this.state.notificationMsg.color,
            icon: this.state.notificationMsg.icon
          }}
          close={this.setNotification}
        />
        <StatusModal
          modal={this.state.modalOpen === true ? "opened" : "closed"}
          action={"choice"}
          handleOpenClose={e => this.closeModal(e)}
          buttonActions={{
            button2: this.closeEP,
            button1: this.closeEP
          }}
          msg={
            "There are unsaved changes. Please select one of the following actions."
          }
          active={true}
          buttonText2={"Save"}
          buttonText={"Discard"}
        />
      </div>
    );
  }
}
export default ManageVendorInformationByDc;
